// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"9bd6e3cf","498":"0007770d","703":"69530155","787":"bab085d0"}[chunkId] + ".chunk.js";
};